import React from 'react';

import { AdminNotificationPanelLayout } from 'design/adminNotificationPanelLayout';
import { BankingSessionStatusPanel } from './BankingSessionStatusPanel';

type Props = {};

export const AdminNotificationPanel = (props: Props) => {
  return (
    <AdminNotificationPanelLayout
      leftSlot={<BankingSessionStatusPanel bankName="PRIOR" />}
      rightSlot={<BankingSessionStatusPanel bankName="NBRB" />}
    />
  );
};
